import styled from 'styled-components'

export const NoneTextStyled = styled.span`
  font-style: italic;
  color: ${(props) => props.theme.colors.text.disabled};
`
